import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { db } from './../../Firebase'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';




const useStyles = makeStyles((theme) => ({
    root: {
        paddingTop: '25px',
        flexGrow: 1,
        width: '90%',
        margin: 'auto',
        paddingBottom: '25px',
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    paperLegal: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        minHeight: '80px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
}));
function Legal() {
    const classes = useStyles();
    //Abrir las listas

    //Triutacion
    const [open, setOpen] = useState(true);
    const [openSuscritos, setOpenSuscritos] = useState(true);
    //Inversion
    const [openInversion, setOpenInversion] = useState(true);
    const [openSuscritosInversion, setOpenSuscritosInversion] = useState(true);
    //Comerciales
    const [openComercial, setOpenComercial] = useState(true);
    const [openSuscritosComercial, setOpenSuscritosComercial] = useState(true);


    //Funciones Open

    const handleClick = () => {
        setOpen(!open);
    };

    const handleClickSuscritos = () => {
        setOpenSuscritos(!openSuscritos);
    };

    const handleClickInversion = () => {
        setOpenInversion(!openInversion);
    };

    const handleClickSuscritosInversion = () => {
        setOpenSuscritosInversion(!openSuscritosInversion);
    };

    const handleClickComercial = () => {
        setOpenComercial(!openComercial);
    };

    const handleClickSuscritosComercial = () => {
        setOpenSuscritosComercial(!openSuscritosComercial);
    };


    //Data
    const [data, setData] = useState(null)
    // Get data from firebase
    useEffect(() => {
        db.collection('Pruebas').doc('Legal')
            .onSnapshot(snapshot => {
                setData(snapshot.data())
            }
            )
    }, [])
    return (
        <div className={classes.root}>
            <Grid container spacing={3}>




                {/*Acuerdos */}
                <Grid item xs={12} sm={12} lg={4}>
                    <Paper className={classes.paper}>

                        <List
                            component="nav"
                            aria-labelledby="nested-list-subheader"
                            className={classes.root}
                        >

                            <ListItem button onClick={handleClick}>
                                {data?.AcuerdosDobleTributaciónVigentes && (
                                    <ListItemIcon>
                                        <h1 className="legal-number">{data.AcuerdosDobleTributaciónVigentes.length}</h1>
                                    </ListItemIcon>
                                )}
                                <ListItemText primary="Acuerdos Doble Tributación Vigentes" style={{ 'fontWeight': '800' }} />
                                {open ? <ExpandLess /> : <ExpandMore />}
                            </ListItem>
                            <Collapse in={open} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>


                                    {data?.AcuerdosDobleTributaciónVigentes?.map((item) => (
                                        <ListItem key={item} button className={classes.nested}>
                                            <ListItemText primary={item} />
                                        </ListItem>
                                    ))}

                                </List>
                            </Collapse>

                            {/*Suscritos*/}
                            <ListItem button onClick={handleClickSuscritos}>
                                {data?.AcuerdosDobleTributaciónVigentesSuscritos && (
                                    <ListItemIcon>
                                        <h1 className="legal-number">{data.AcuerdosDobleTributaciónVigentesSuscritos.length}</h1>
                                    </ListItemIcon>
                                )}
                                <ListItemText primary="Suscritos" />
                                {openSuscritos ? <ExpandLess /> : <ExpandMore />}
                            </ListItem>
                            <Collapse in={openSuscritos} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>


                                    {data?.AcuerdosDobleTributaciónVigentesSuscritos?.map((item) => (
                                        <ListItem key={item} button className={classes.nested}>
                                            <ListItemText primary={item} />
                                        </ListItem>
                                    ))}

                                </List>
                            </Collapse>

                        </List>


                    </Paper>
                </Grid>
                {/*Acuerdos de Inversión*/}
                <Grid item xs={12} sm={12} lg={4}>
                    <Paper className={classes.paper}>
                        <List
                            component="nav"
                            aria-labelledby="nested-list-subheader"
                            className={classes.root}
                        >

                            <ListItem button onClick={handleClickInversion}>
                                {data?.AcuerdosdeInversiónVigentes && (
                                    <ListItemIcon>
                                        <h1 className="legal-number">{
                                            data.AcuerdosdeInversiónVigentes.length}
                                        </h1>
                                    </ListItemIcon>
                                )}
                                <ListItemText primary="Acuerdos de Inversión Vigentes" />
                                {openInversion ? <ExpandLess /> : <ExpandMore />}
                            </ListItem>
                            <Collapse in={openInversion} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>


                                    {data?.AcuerdosdeInversiónVigentes?.map((item) => (
                                        <ListItem key={item} button className={classes.nested}>
                                            <ListItemText primary={item} />
                                        </ListItem>
                                    ))}

                                </List>
                            </Collapse>

                            {/*Suscritos*/}
                            <ListItem button onClick={handleClickSuscritosInversion}>
                                {data?.AcuerdosdeInversiónVigentesSuscritos && (
                                    <ListItemIcon>
                                        <h1 className="legal-number">{data.AcuerdosdeInversiónVigentesSuscritos.length}</h1>
                                    </ListItemIcon>
                                )}
                                <ListItemText primary="Suscritos" />
                                {openSuscritosInversion ? <ExpandLess /> : <ExpandMore />}
                            </ListItem>
                            <Collapse in={openSuscritosInversion} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>


                                    {data?.AcuerdosdeInversiónVigentesSuscritos?.map((item) => (
                                        <ListItem key={item} button className={classes.nested}>
                                            <ListItemText primary={item} />
                                        </ListItem>
                                    ))}

                                </List>
                            </Collapse>

                        </List>

                    </Paper>
                </Grid>
                <Grid item xs={12} sm={12} lg={4}>
                    <Paper className={classes.paper}>
                        <List
                            component="nav"
                            aria-labelledby="nested-list-subheader"
                            className={classes.root}
                        >

                            <ListItem button onClick={handleClickComercial}>
                                {data?.AcuerdosComercialesVigentes && (
                                    <ListItemIcon>
                                        <h1 className="legal-number">{
                                            data.AcuerdosComercialesVigentes.length}
                                        </h1>
                                    </ListItemIcon>
                                )}
                                <ListItemText primary="Acuerdos Comerciales Vigentes" />
                                {openComercial ? <ExpandLess /> : <ExpandMore />}
                            </ListItem>
                            <Collapse in={openComercial} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>


                                    {data?.AcuerdosComercialesVigentes?.map((item) => (
                                        <ListItem key={item} button className={classes.nested}>
                                            <ListItemText primary={item} />
                                        </ListItem>
                                    ))}

                                </List>
                            </Collapse>

                            {/*Suscritos*/}
                            <ListItem button onClick={handleClickSuscritosComercial}>
                                {data?.AcuerdosComercialesVigentesSuscritos && (
                                    <ListItemIcon>
                                        <h1 className="legal-number">{data.AcuerdosComercialesVigentesSuscritos.length}</h1>
                                    </ListItemIcon>
                                )}
                                <ListItemText primary="Suscritos" />
                                {openSuscritosComercial ? <ExpandLess /> : <ExpandMore />}
                            </ListItem>
                            <Collapse in={openSuscritosComercial} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>


                                    {data?.AcuerdosComercialesVigentesSuscritos?.map((item) => (
                                        <ListItem key={item} button className={classes.nested}>
                                            <ListItemText primary={item} />
                                        </ListItem>
                                    ))}

                                </List>
                            </Collapse>

                        </List>

                    </Paper>
                </Grid>


                <Grid item xs={12} sm={12} lg={12}>
                    {/*Pie de Pagina o anotaciones */}

                    {data?.PiesdePagina?.map((item) => (
                        <span key={item}>{item}</span>
                    ))}

                </Grid>

            </Grid>

        </div>
    );

}

export default Legal
